import { render } from "./FluturasSalariu.vue?vue&type=template&id=48d61362&scoped=true&ts=true"
import script from "./FluturasSalariu.vue?vue&type=script&lang=ts"
export * from "./FluturasSalariu.vue?vue&type=script&lang=ts"

import "./FluturasSalariu.vue?vue&type=style&index=0&id=48d61362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d61362"]])

export default __exports__